const style = (theme) => ({
  formContainer: {
    maxHeight: '40vh',
    overflow: 'auto',
    padding: theme.spacing(2.5, 2, 2),
  },
})

export default style
